import { IDocumentDetailField } from 'common/document/interfaces/document-detail-field';
import { DocumentDetailFieldStatusEnum } from 'common/document/enums/document-detail-field-status.enum';

export type IFieldVerified = { [key: string]: boolean };

export const buildFieldVerified = (
  inputData: IDocumentDetailField[] | null | undefined
): IFieldVerified | null => {
  if (!inputData?.length || !Object.keys(inputData).length) {
    return null;
  }
  return Object.values(inputData).reduce(
    (hash: { [key: string]: any }, currentValue: any) => {
      hash[currentValue.fieldName] =
        currentValue?.verificationStatus ===
        DocumentDetailFieldStatusEnum.SUCCESS;
      return hash;
    },
    {}
  );
};
